import {AboutPageProps, MetaTagsProps} from "@/types";
import {OG_PATH, WEBSITE_URL, BUSINESS_NAME} from "@/content";

export const metaTagsAbout : MetaTagsProps = {
    title: `${BUSINESS_NAME} - About Us`,
    description: `${BUSINESS_NAME} is a Sydney excavation company specialising in mini excavation, footings, trenching, pool demolition, underground basements, site cuts and more. Learn about our expertise, safety standards, and dedication to quality service.`,
    keywords: "about harris excavation, excavation company sydney, mini excavation sydney, pool demolition sydney, trenching and footings, site cuts and benching, basement excavation",
    url: `${WEBSITE_URL}/about`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const aboutPageContent : AboutPageProps = {
    title: `About Us | ${BUSINESS_NAME} Sydney`,
    description: `${BUSINESS_NAME} Services is a Sydney-based excavation company delivering expert residential, commercial, and industrial excavation solutions. With years of experience, modern equipment, and a commitment to safety and precision, we specialise in everything from mini excavation and footings to large-scale site cuts and basement digs. Our mission is to provide reliable, cost-effective excavation services that support builders, homeowners, and developers across Sydney.`,
    images: [],
}
